import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { TemplateBuilderReducerState } from "./types";
import * as AC from "./actionCreators";
import byIdReducer from "./subreducers/byIdReducer";

const initialState: TemplateBuilderReducerState = {
  byId: {},
};

const templateBuilderReducer = reducer(
  initialState,
  on(...union(...Object.values(AC)), (state, action) => {
    if (action.error) return;

    // eslint-disable-next-line no-param-reassign
    state.byId = byIdReducer(state.byId, action);
  })
);

export default templateBuilderReducer;
